import { apiSlice } from "./apiSlice";

export const publisherAdminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPublisherAdmin: builder.query({
      query: (publisherId) => ({
        url: `/publishers_admin/${publisherId}`
      }),
      providesTags: (result = [], error, publisherId) => [{ type: 'Publisher', id: `admin:${publisherId}` } ],
    }),
    getPublisherExclusive: builder.query({
      query: (publisherId) => ({
        url: `/publishers_admin/${publisherId}/exclusive`
      }),
      providesTags: (result = [], error, publisherId) => [{ type: 'Publisher', id: `exclusive:${publisherId}` } ],
    }),
    getPublisherAdminDataByDay: builder.query({
      query: (publisherId ) => ({
        url: `/publishers_admin/${publisherId}/data_by_day`
      }),
      providesTags: (result = [], error, publisherId) => [{ type: 'Publisher', id: `admin_data_by_day:${publisherId}` } ],
    }),
    getPublisherAdminLocationStatus: builder.query({
      query: (publisherId) => ({
        url: `/publishers_admin/${publisherId}/location_status`
      }),
      providesTags: (result = [], error, publisherId) => [{ type: 'Publisher', id: `location_status:${publisherId}` } ],
    }),
    getPublisherAdminSdkVersionPerOs: builder.query({
      query: (publisherId) => ({
        url: `/publishers_admin/${publisherId}/sdk_version_per_os`
      }),
      providesTags: (result = [], error, publisherId) => [{ type: 'Publisher', id: `sdk_version_per_os:${publisherId}` } ],
    }),
    getPublisherAdminOsVersionPerOs: builder.query({
      query: (publisherId) => ({
        url: `/publishers_admin/${publisherId}/os_version_per_os`
      }),
      providesTags: (result = [], error, publisherId) => [{ type: 'Publisher', id: `os_version_per_os:${publisherId}` } ],
    }),
    getPublisherAdminSdkVersionPerDay: builder.query({
      query: (publisherId) => ({
        url: `/publishers_admin/${publisherId}/sdk_version_by_day`
      }),
      providesTags: (result = [], error, publisherId) => [{ type: 'Publisher', id: `sdk_version_by_day:${publisherId}` } ],
    }),
    getPublisherAdminOsVersionPerDay: builder.query({
      query: (publisherId) => ({
        url: `/publishers_admin/${publisherId}/os_version_by_day`
      }),
      providesTags: (result = [], error, publisherId) => [{ type: 'Publisher', id: `os_version_by_day:${publisherId}` } ],
    }),
    getPublisherAdminLocationStatusPerOsVersion: builder.query({
      query: (publisherId) => ({
        url: `/publishers_admin/${publisherId}/location_status_per_os_version`
      }),
      providesTags: (result = [], error, publisherId) => [{ type: 'Publisher', id: `location_status_per_os_version:${publisherId}` } ],
    }),
  }),
  overrideExisting: false
})

export const {
  useGetPublisherAdminQuery,
  useGetPublisherExclusiveQuery,
  useGetPublisherAdminDataByDayQuery,
  useGetPublisherAdminLocationStatusQuery,
  useGetPublisherAdminSdkVersionPerOsQuery,
  useGetPublisherAdminOsVersionPerOsQuery,
  useGetPublisherAdminSdkVersionPerDayQuery,
  useGetPublisherAdminOsVersionPerDayQuery,
  useGetPublisherAdminLocationStatusPerOsVersionQuery
} = publisherAdminApiSlice
